var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicles-list-actions"},[_c('former-button',{staticClass:"vehicles-list-action",attrs:{"size":"small","icon":"pen"},on:{"click":_vm.change}},[_vm._v("\n    Editar veículo\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }